import { OnboardingLiveCreationIntentStatus } from "../gql/graphql.ts";

export const creationIntentStatusLabels: Record<
  OnboardingLiveCreationIntentStatus,
  string
> = {
  [OnboardingLiveCreationIntentStatus.Draft]: "Bozza",
  [OnboardingLiveCreationIntentStatus.Confirmed]: "Creazione in corso",
  [OnboardingLiveCreationIntentStatus.Completed]: "Completata",
  [OnboardingLiveCreationIntentStatus.Cancelled]: "Annullata",
};
